<div class="d-flex align-items-center justify-content-{{ item.headerAlign }} fs-14 {{ item.customHeaderClass }}" [matMenuTriggerFor]="item.isSortable ? menu : null">
  @if (item.isSortable) {
    <span class="fw text-dark" (click)="sortBy = item.sortByKey">{{ item.title }}</span>
    @if (inputSortOrder.sortBy === item.sortByKey && inputSortOrder.sortOrder === "Asc") {
      <mat-icon class="d-flex align-items-center px-1 fs-16 text-dark asc-order-icon">arrow_upward</mat-icon>
    } @else if (inputSortOrder.sortBy === item.sortByKey && inputSortOrder.sortOrder === "Desc") {
      <mat-icon class="d-flex align-items-center px-1 fs-16 text-dark desc-order-icon">arrow_downward</mat-icon>
    } @else {
      <mat-icon class="d-flex align-items-center text-dark px-1 fs-16 none-order-icon">unfold_more</mat-icon>
    }
  } @else {
    <span class="fw text-dark">{{ item.title }}</span>
  }
</div>

<mat-menu #menu="matMenu" [hasBackdrop]="true" backdropClass="option-panel-backdrop-class">
  <div class="mat-menu">
    @if (inputSortOrder.sortBy === sortBy) {
      @if (inputSortOrder.sortOrder.toLowerCase() !== "asc") {
        <div (click)="onSortEmitter('Asc')" class="menu-item"><mat-icon class="menu-item_icon">arrow_upward</mat-icon><span class="menu-item_text">Asc</span></div>
      }

      @if (inputSortOrder.sortOrder.toLowerCase() !== "desc") {
        <div (click)="onSortEmitter('Desc')" class="menu-item"><mat-icon class="menu-item_icon">arrow_downward</mat-icon><span class="menu-item_text">Desc</span></div>
      }
    } @else {
      <div (click)="onSortEmitter('Asc')" class="menu-item"><mat-icon class="menu-item_icon">arrow_upward</mat-icon><span class="menu-item_text">Asc</span></div>
      <div (click)="onSortEmitter('Desc')" class="menu-item"><mat-icon class="menu-item_icon">arrow_downward</mat-icon><span class="menu-item_text">Desc</span></div>
    }

    @if (inputSortOrder.sortBy && inputSortOrder.sortOrder && inputSortOrder.sortBy === sortBy) {
      <div (click)="onSortEmitter('')" class="menu-item"><mat-icon class="menu-item_icon">remove</mat-icon><span class="menu-item_text">None</span></div>
    }
    <ng-content select=".more-options"></ng-content>
  </div>
</mat-menu>
